import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Tooltip } from 'antd';
import { useSession } from 'components/Authenticated';
import { txt } from 'libs/i18n';
import { WandIcon } from 'components/CustomIcons';
import IconButton from 'components/IconButton';
import { useSwitch } from 'hooks/useSwitch';
import { useMemo } from 'react';
import AiModal from '../../../../../components/AiModal';
import toolbarStyles from '../style.module.less';
const MIN_PROJECTS_FOR_AI = 2;
const MAX_PROJECTS_FOR_AI = 50;
const AiButton = ({ selectionEmpty, selectedProjects, }) => {
    const { session: { login } } = useSession();
    const [openDialog, onOpenDialog, onCloseDialog] = useSwitch();
    const canUseAI = login.hasClaim('aitools:all');
    if (!canUseAI) {
        return null;
    }
    const isDisabled = useMemo(() => selectionEmpty
        || selectedProjects.length < MIN_PROJECTS_FOR_AI
        || selectedProjects.length > MAX_PROJECTS_FOR_AI, [selectionEmpty, selectedProjects.length]);
    const tooltipText = useMemo(() => {
        if (selectedProjects.length < MIN_PROJECTS_FOR_AI) {
            return txt('selectAtLeastTwoItemsForSmartEdits');
        }
        if (selectedProjects.length > MAX_PROJECTS_FOR_AI) {
            return txt('selectUpTo50ItemsForSmartEdits');
        }
        return txt('smartEdits');
    }, [selectedProjects.length]);
    return (_jsxs("div", { children: [_jsx(Tooltip, { title: tooltipText, children: _jsx("span", { children: _jsx(IconButton, { disabled: isDisabled, onClick: onOpenDialog, className: toolbarStyles.toolbarButton, children: _jsx("span", { className: toolbarStyles.wandIcon, children: _jsx(WandIcon, {}) }) }) }) }), !selectionEmpty && (_jsx(AiModal, { visible: openDialog, onClose: onCloseDialog, projectConfig: { projectType: 'multiple', projectList: selectedProjects }, preselectedPrompt: null }))] }));
};
export default AiButton;
